import Vue from 'vue'
import Vuex from 'vuex'
// import {userInfos} from "@/api/api";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // count:0,
    // obj: ''
  },
  mutations: {
    // Details(state, patload) {
    //   console.log(patload)
    //   state.obj=patload;
    // }
  },
  actions: {  
    // listact(contetx) {
    //   console.log(contetx);
    //   userInfos({}).then((res) => {
    //     console.log(res.data.data);
    //     contetx.commit("Details", res.data.data)
    //   });
    // }
  },
  modules: {
    
  }
})
